export const STORE_LOAD = 'STORE_LOAD';
export const STORE_LOAD_SUCCESS = 'STORE_LOAD_SUCCESS';
export const STORE_LOAD_FAIL = 'STORE_LOAD_FAIL';
export const RESET_STORE_DATA = 'RESET_STORE_DATA';
export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const CREATE_APPOINTMENT_SUCCESS = 'CREATE_APPOINTMENT_SUCCESS';
export const CREATE_APPOINTMENT_FAIL = 'CREATE_APPOINTMENT_FAIL';
export const STORE_PRODUCT_FOR_PINCODE = 'STORE_PRODUCT_FOR_PINCODE';
